// Types
import { VBANDetails } from "../../../redux/modules/clientManagement/reducer";

export interface VbanCodeLabel {
    label: string;
    value: string;
    fieldType: string;
}

export const getVbanCodeLabelMapping = ((translate: (arg: string) => any, vbanDetailsResult: VBANDetails | null) => {
    const bankNameCodeLabel: string = translate('clientmanagement.vbanDetailsPanel.fieldNames.bankName');
    const accountNoCodeLabel: string = translate('clientmanagement.vbanDetailsPanel.fieldNames.accountNo');
    const accountTypeCodeLabel: string = translate('clientmanagement.vbanDetailsPanel.fieldNames.accountType');
    const wireRoutingNumberCodeLabel: string = translate('clientmanagement.vbanDetailsPanel.fieldNames.wireRoutingNumber');
    const achRoutingNumberCodeLabel: string = translate('clientmanagement.vbanDetailsPanel.fieldNames.achRoutingNumber');
    const currencyLabel: string = translate('clientmanagement.vbanDetailsPanel.fieldNames.currency');

    const { bankName, ibanAccountNumber, accountType, wireRoutingNumber, achRoutingNumber, currency } = vbanDetailsResult || {};

    const codeLabels: VbanCodeLabel[] = [
        {
            label: bankNameCodeLabel,
            value: bankName ?? '',
            fieldType: 'bankName'
        },
        {
            label: accountNoCodeLabel,
            value: ibanAccountNumber ?? '',
            fieldType: 'ibanAccountNumber'
        },
        {
            label: accountTypeCodeLabel,
            value: accountType ?? '',
            fieldType: 'accountType'
        },
        {
            label: wireRoutingNumberCodeLabel,
            value: wireRoutingNumber ?? '',
            fieldType: 'wireRoutingNumber'
        },
        {
            label: achRoutingNumberCodeLabel,
            value: achRoutingNumber ?? '',
            fieldType: 'achRoutingNumber'
        },
        {
            label: currencyLabel,
            value: currency ?? '',
            fieldType: 'currency'
        }
    ];

    return codeLabels;
});